import Cookies from 'js-cookie'
import {
  ApiExecute
} from '@utils/tool'
import {
//   getToken,
//   removeToken
  setToken
} from '@utils/auth'
import GLOBALVAR from '@/Api/global_variable'
const user = {
  state: {
    info: {},
    token: '',
    uid: Cookies.get('uid'),
    hadAddRoutes: false,
    roles: [],
    isAdmin: false,
    mobile: '',
    email: '',
    IsLevel2AuditAuth: '',
    isFirstLogin: false,
    username: '',
    isAuthentication: ''
  },
  mutations: {
    SET_USER(state, user) {
      var _user = _.merge({}, state.user)
      if (!_.size(_user)) {
        _user = {}
      }
      _.each(user, function (value, key) {
        _user[key] = value
      })
      state.info = _user
    },
    SET_ISADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    },
    SET_HADADDROUTES: (state, hadAddRoutes) => {
      state.hadAddRoutes = hadAddRoutes
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_CASEFORMVERSION: (state, val) => {
      state.info.caseFormVersion = val
    },
    LOGOUT(state) {
      sessionStorage.clear()
      state.user = {}
      state.token = null
    },
    // 更新未读消息数量
    UPDATE_NOREADMESSAGECOUNT(state, val) {
      state.info.NoReadCount = val
    },
    // 更新新旧版本
    UPDATE_CASEFORMVERSION(state, val) {
      state.info.caseFormVersion = val
    },
    SET_MOBILE(state, val) {
      state.mobile = val
    },
    SET_EMAIL(state, val) {
      state.email = val
    },
    SET_IsAuthentication(state, val) {
      state.isAuthentication = val
    },
    SET_IsLevel2AuditAuth(state, val) {
      state.IsLevel2AuditAuth = val
    },
    // guandong_20221102
    SET_IS_FIRST_LOGIN: (state, status) => {
      state.isFirstLogin = status
    },
    SET_USERNAME: (state, data) => {
      state.username = data
    }
  },
  actions: {
    // 用户名登录
    LoginByUsername({
      commit
    }, userInfo) {
      if (userInfo.Account) {
        const username = userInfo.Account.trim()
      }
      return new Promise((resolve, reject) => {
        ApiExecute(userInfo)
          .then(res => {
            commit('SET_TOKEN', res.Token)
            commit('SET_HADADDROUTES', false)
            setToken(res.Token)
            Cookies.set('uid', res.UID)
            commit('SET_IS_FIRST_LOGIN', true)
            commit('SET_USERNAME', res.Account || '')
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetUserInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        ApiExecute({
          AppID: GLOBALVAR.AppID,
          Method: 'GetUserRegister'
        })
          .then(res => {
            commit('SET_HADADDROUTES', true)
            commit('SET_USER', res)
            commit('SET_TOKEN', res.token)
            commit('SET_CASEFORMVERSION', res.NewCaseMainVersion)
            commit('SET_MOBILE', res.Mobile)
            commit('SET_EMAIL', res.Email)
            commit('SET_IsAuthentication', res.IsAuthentication)
            Cookies.set('isReport', res.IsReadSmarteeAnnualReport)
            Cookies.set('userType', res.Type)
            // 是否有二级审核权限
            commit('SET_IsLevel2AuditAuth', res.IsLevel2AuditAuth)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 注销
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        ApiExecute({
            TAppID: 7,
            Method: 'Logoff',
            AppID: 3 // 应用号
          })
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise((resolve, reject) => {
        ApiExecute({
          AppID: 7,
          Method: 'Logoff',
          TAppID: 12 // 应用号
        }).then(() => {
          window.localStorage.clear()
          Cookies.remove('token')
          Cookies.remove('uid')
          Cookies.remove('appID')
          Cookies.remove('account')
          Cookies.remove('Admin-Token')
          Cookies.remove('isReport')
          Cookies.remove('userType')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js